export default {
  label: 'Publicações com id',
};
